export var CLASSNAME_SUFFIX_MAP = {
    // group
    gridGroup: 'grid-group',
    mainGroup: 'main-group',
    lineGroup: 'line-group',
    tickGroup: 'tick-group',
    labelGroup: 'label-group',
    titleGroup: 'title-group',
    // content
    grid: 'grid',
    line: 'line',
    lineFirst: 'line-first',
    lineSecond: 'line-second',
    tick: 'tick',
    tickItem: 'tick-item',
    label: 'label',
    labelItem: 'label-item',
    title: 'title',
};
//# sourceMappingURL=classname-map.js.map